import throttle from '@/js/helpers/throttle'

let isMobile = window.innerWidth < 767

window.addEventListener('resize', throttle(() => {
  isMobile = window.innerWidth < 767
}, 100))

export default isMobile
